import React from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import { Text, View } from '@coinscrap/webapp-core';
import { capitalize } from 'helpers/capitalize';
import { MainButton } from '../../../components/MainButton/MainButton';
import * as S from './styles';

export const PackageCoverageHeader = ({ packages, selectedPack, selectPack }) => {
	// console.log('selectedPack', selectedPack);
	return (
		<>
			{isMobile ? (
				<View gap2St>
					{packages.length > 0 &&
						packages.map((pack, index) => (
							<View key={index}>
								<View
									displayGridSt
									gridCols3St
									gap4St
									coverageHeadMobileSt
									onClick={() => selectPack(pack)}
								>
									<View colSpan2St rowSt justifyStartSt alignItemsCenterSt gap2St>
										<S.RadioButton selected={selectedPack?.id === pack.id}>
											<S.RadioButtonInt
												selected={selectedPack?.id === pack.id}
											/>
										</S.RadioButton>
										<Text coverageMobileHeaderSt>
											{capitalize(pack.modalityDescription, true)}
										</Text>
									</View>
									<View>
										<Text packReceiptSt>{pack.totalPremiumAmount}€</Text>
									</View>
								</View>
							</View>
						))}
					<View>
						<Text>
							Precio condicionado a la comprobación de los datos que nos has
							facilitado.
						</Text>
					</View>
				</View>
			) : (
				<View displayGridSt alignGridItemsStartSt gridCols5St gap4St>
					<View colSpan2St>
						<Text>
							Precio condicionado a la comprobación de los datos que nos has
							facilitado.
						</Text>
					</View>
					{packages.length > 0 &&
						packages.map((pack, index) => {
							// console.log('pack', pack);
							return (
								<View key={index}>
									<View
										tableFirstRowSt
										justifyStartSt
										style={{
											backgroundColor:
												selectedPack?.id === pack.id
													? CONFIG.colors.primary
													: undefined,
										}}
									>
										<View packHeaderCellSt>
											<Text packHeaderCellSt>
												{capitalize(pack.modalityDescription, true)}
											</Text>
										</View>
										<View style={{ padding: '20px 10px' }}>
											<View>
												<Text
													packReceiptSt
													style={{
														color:
															selectedPack?.id === pack.id
																? CONFIG.colors.white
																: undefined,
													}}
												>
													{pack.totalPremiumAmount}€
												</Text>
											</View>
											<MainButton
												onClick={() => selectPack(pack)}
												style={{
													marginTop: 10,
													backgroundColor: CONFIG.colors.white,
													borderColor: CONFIG.colors.primary,
													textColor: CONFIG.colors.primary,
													fontFamily: CONFIG.fonts.regular,
												}}
											>
												Seleccionar
											</MainButton>
										</View>
									</View>
								</View>
							);
						})}
				</View>
			)}
		</>
	);
};
